import React from 'react';
import { Input } from 'antd';
import { CustomComponentProps } from '../types';

/**
 * Custom Input wrapper component
 * This allows easy styling and replacement with other libraries
 */
export interface MyInputProps extends CustomComponentProps {
  type?: 'text' | 'password' | 'email' | 'number' | 'phone';
  maxLength?: number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  allowClear?: boolean;
  size?: 'small' | 'middle' | 'large';
}

const MyInput: React.FC<MyInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  readonly,
  type = 'text',
  maxLength,
  prefix,
  suffix,
  allowClear = true,
  size = 'middle',
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  // Use Password component for password type
  if (type === 'password') {
    return (
      <Input.Password
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled || readonly}
        maxLength={maxLength}
        prefix={prefix}
        suffix={suffix}
        allowClear={allowClear}
        size={size}
        {...rest}
      />
    );
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled || readonly}
      type={type}
      maxLength={maxLength}
      prefix={prefix}
      suffix={suffix}
      allowClear={allowClear}
      size={size}
      {...rest}
    />
  );
};

export default MyInput;
